import React from "react";
import IpadCardList from "./IpadCardList";

const IpadCardAll = () => {
  return (
    <>
      <div style={{ backgroundColor: "#2C3539" }}>
        <br /> <br /> <br /> <br />
        <IpadCardList />
        <br />
        <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
      </div>
    </>
  );
};

export default IpadCardAll;
